// extracted by mini-css-extract-plugin
module.exports = {"training_path_pagination":"buttonComponent_training_path_pagination__2x0QD","cancel":"buttonComponent_cancel__2EfZO","submit":"buttonComponent_submit__wi_fe"};